// extracted by mini-css-extract-plugin
export default {"bottomSeparator":"EventDetails_bottomSeparator__FJgn0","linkStyle":"EventDetails_linkStyle__TICpx","toggleBtn":"EventDetails_toggleBtn__LfUJ8","footer":"EventDetails_footer__XzABl"};